export const drugsConstants = {
  GETDRUGS_REQUEST: 'GETDRUGS_REQUEST',
  GETDRUGS_SUCCESS: 'GETDRUGS_SUCCESS',
  GETDRUGS_FAILURE: 'GETDRUGS_FAILURE',
};
